import(/* webpackMode: "eager" */ "/codebuild/output/src142463875/src/doctor-dashboard/src/components/loader/AppLoader.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src142463875/src/doctor-dashboard/src/components/loader/SplashScreenLoader.tsx");
